import { defineComponent } from 'vue';
import { Modal } from 'ant-design-vue';
import { useStoreLoginModal } from '@src/store/modules/loginModal';
import Login from '@src/views/Login/index';
import './index.scss';

export default defineComponent({
    name: 'LoginModal',
    setup() {
        const storeLoginModal = useStoreLoginModal();

        return () => (
            <Modal
                class='login-modal'
                open={storeLoginModal.visible}
                onCancel={() => storeLoginModal.close()}
                footer={null}
                maskClosable={false}
                destroyOnClose
                centered
            >
                <Login />
            </Modal>
        );
    },
});
